import { render, staticRenderFns } from "./CartProductDetails.vue?vue&type=template&id=90025b0c&scoped=true"
import script from "./CartProductDetails.vue?vue&type=script&lang=js"
export * from "./CartProductDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90025b0c",
  null
  
)

export default component.exports